import { useState, useContext, useEffect } from 'react';
import { signInWithPopup, getAdditionalUserInfo, ProviderId } from 'firebase/auth';
import {
  auth, googleProvider, facebookProvider, appleProvider,
} from '../utils/firebase';
import { AuthContext } from '../context/AuthContext';
import useCreateUser from './useCreateUser';
import { APPLE_PROVIDER } from '../constants/constants';

const useSignIn = () => {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const { login } = useContext(AuthContext);
  const { createUser, error: creationError, success: creationSuccess } = useCreateUser();

  useEffect(() => {
    setError(creationError);
  }, [creationError]);

  useEffect(() => {
    setSuccess(creationSuccess);
  }, [creationSuccess]);

  const getProvider = (provider) => {
    switch (provider) {
      case ProviderId.GOOGLE:
        return googleProvider;
      case ProviderId.FACEBOOK:
        return facebookProvider;
      case APPLE_PROVIDER:
        return appleProvider;
      default:
        return null;
    }
  };

  const signIn = async (provider = ProviderId.GOOGLE) => {
    setError(null);
    setIsPending(true);
    setSuccess(false);

    const proivder = getProvider(provider);

    signInWithPopup(auth, proivder).then(async (result) => {
      const loginUser = result.user;
      const additionalUserInfo = getAdditionalUserInfo(result);
      login(loginUser, additionalUserInfo);

      if (additionalUserInfo.isNewUser) {
        await createUser(loginUser, additionalUserInfo);
      } else {
        setSuccess(true);
      }
      setIsPending(false);
    }).catch((e) => {
      setError(e);
      setIsPending(false);
    });
  };

  return {
    signIn, error, success, isPending,
  };
};

export default useSignIn;
